/**
 * Boona Direct seen from the journal (boona repo: docs/codebase/inbox/README.md §9):
 * whether to show the Chats entry, and the unread badge. The journal never opens a
 * stream of its own — it polls inbox-web's cheap /api/summary.
 */
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { getAuthRegistry } from "@/lib/auth/AuthRegistry";
import { inboxApiBase } from "@/lib/inbox/links";

export interface InboxAccess {
  company_id: number;
  yuser_id: number | null;
  module_active: boolean;
  access: { inbox_access: boolean; timetable_phones_access: boolean; clients_access: boolean };
}

/** The shard's answer (the same one inbox-web caches): module on + permission. */
export function useInboxAccess() {
  return useQuery({
    queryKey: ["inboxAccess"],
    queryFn: async () => (await apiClient.get<InboxAccess>("/api/v1/company/inbox-access")).data,
    staleTime: 10 * 60_000,
    retry: false,
  });
}

export function useInboxEnabled(): boolean {
  const { data } = useInboxAccess();
  return !!data?.module_active && !!data?.access?.inbox_access;
}

export function useInboxUnread(enabled: boolean) {
  return useQuery({
    queryKey: ["inboxSummary"],
    queryFn: async () => {
      const token = getAuthRegistry().getTokens().accessToken;
      const res = await fetch(`${inboxApiBase()}/api/summary`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) throw new Error(`inbox summary ${res.status}`);
      return (await res.json()) as { unread_threads: number; unread_messages: number };
    },
    enabled,
    refetchInterval: 60_000,
    retry: false,
  });
}
